import { useState, useEffect, useCallback } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { meetingsAPI } from '../../lib/api';
import MeetingListRow from './MeetingListRow';

// Test 4 (spec TESTS list): Admin and Super Admin must see every meeting, not only
// their own or their team's.
export default function AllMeetingsTab() {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('all');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { view: 'all' };
      if (status !== 'all') params.status = status;
      const res = await meetingsAPI.list(params);
      setMeetings(res.data.meetings || []);
    } catch { toast.error('Failed to load every meeting'); }
    finally { setLoading(false); }
  }, [status]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="all-meetings-tab">
      <Select value={status} onValueChange={setStatus}>
        <SelectTrigger className="w-44" data-testid="all-meetings-status-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All statuses</SelectItem>
          <SelectItem value="PLANNED">Planned</SelectItem>
          <SelectItem value="REPORT_DUE">Report Due</SelectItem>
          <SelectItem value="SUBMITTED">Submitted</SelectItem>
          <SelectItem value="SENT_BACK">Sent Back</SelectItem>
          <SelectItem value="REVIEWED">Reviewed</SelectItem>
        </SelectContent>
      </Select>
      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="animate-spin" /></div>
      ) : meetings.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-8" data-testid="no-all-meetings-msg">No meetings found.</p>
      ) : (
        <div className="space-y-2">{meetings.map((m) => <MeetingListRow key={m.id} meeting={m} />)}</div>
      )}
    </div>
  );
}
